module.exports = __webpack_public_path__ + "static/media/jobCommentsHeader.33345e6f.jpg";